module.exports = __webpack_public_path__ + "img/m3.68f98dd9.jpeg";